import React, { useEffect, useState } from "react";
import "./Login.css";
import InputType from "../../components/UI/InputType/InputType";
import Toolbar from "../../components/Navigation/Toolbar/Toolbar";
import Sidedrawer from "../../components/Navigation/Sidedrawer/Sidedrawer";
import axios from "axios";
import { setCookie, getCookie } from "../../components/Utils/Cookie";
import { Subscribe } from "unstated";
import RECSPContainer from "../../Store/recspContainer";
import GoogleLogin from "react-google-login";
import { useLocation } from "wouter";


/* ---------------------- Layout Wrapper ---------------------- */
export function Layout2({ children }) {
  const [state, setState] = useState({ showSideDrawer: false });

  const sideDrawerCloseHandler = () => setState({ showSideDrawer: false });
  const openToogleMenu = () => setState({ showSideDrawer: true });

  useEffect(() => {
    if (getCookie("_RSPRFTOKEN") !== "") {}
  }, []);

  return (
    <>
      <Toolbar openMenu={openToogleMenu} />
      <Sidedrawer open={state.showSideDrawer} closed={sideDrawerCloseHandler} />
      <main>{children}</main>
    </>
  );
}


/* ---------------------- LOGIN COMPONENT ---------------------- */
export default function Login() {
  const [location, setLocation] = useLocation();

  const [state, setState] = useState({
    email: null,
    password: null,
    loading: false,
    google_email: null,
    google_token: null,
    error: null,
  });

  /* ------------ Input Validators ------------ */
  const onEmailChangeHandler = (e) => isValidEmail(e.target.value);
  const onPasswordChangeHandler = (e) => isValidPassword(e.target.value);

  const isValidEmail = (val) => {
    val = val.trim();
    setState(s => ({
      ...s,
      email: val.includes("@") && val.includes(".") ? val : null,
      error: val.includes("@") && val.includes(".") ? null : "Invalid Email"
    }));
  };

  const isValidPassword = (val) => {
    setState(s => ({
      ...s,
      password: val.length >= 8 ? val : null,
      error: val.length >= 8 ? null : "Password must be 8 characters long"
    }));
  };


  /* ------------ LOGIN BUTTON ------------ */
  const loginButtonClickHandler = (doLogin) => {
    if (!state.email || !state.password)
      return setState(s=>({...s,error:"Please enter email and password"}));

    setState(s=>({...s,loading:true}));

    axios.post("https://recstudentportal.com/api/v1/authenticateUser.php",
      { email: state.email, password: state.password, key:"cmVhY3RBcHBQb3J0YWwyNjc=" },
      { withCredentials:true, headers:{ "Content-Type":"application/json"} }
    )
    .then(res=>{
      if(res.data.status===201){
        setCookie("_RSPRFTOKEN", res.data.data.refreshToken,30);
        doLogin(res.data.data);
        setLocation("/");
      } else {
        setState(s=>({...s,error:res.data.message,loading:false}));
      }
    })
    .catch(()=>setState(s=>({...s,error:"Something went wrong",loading:false})));
  };


  /* ------------ GOOGLE LOGIN ------------ */
  const resGoogle = (response, doLogin) => {
    axios.post("https://recstudentportal.com/api/v1/googleAuth.php",
      { email:response.profileObj.email, accessToken:response.accessToken, key:"cmVhY3RBcHBQb3J0YWwyNjc=" },
      { withCredentials:true, headers:{"Content-Type":"application/json"} }
    )
    .then(res=>{
      if(res.data.status===201){
        setCookie("_RSPRFTOKEN", res.data.data.refreshToken,30);
        doLogin(res.data.data);
        setLocation("/");
      } else setState(s=>({...s,error:res.data.message}));
    });
  };


  /* ---------------------- UI ---------------------- */
  return (
    <Layout2>
      <div className="login-wrapper">

        <div id="content"></div>

        <div className="LoginFrom">
          {/* HEADER */}
          <div className="head">
            <div className="spanlogin"><span>LOGIN</span></div>
            <p>One Account for Everything</p>
          </div>

          <hr />

          {/* INPUTS */}
          <InputType onChange={onEmailChangeHandler} type="text" placeholder="Email" />
          <InputType onChange={onPasswordChangeHandler} type="password" placeholder="Password" />

          <div className="loginError">{state.error}</div>
          <br/>

          {/* LOGIN BUTTON */}
          <Subscribe to={[RECSPContainer]}>
            {rec=>(
              <button className="logBtn" disabled={state.loading} onClick={()=>loginButtonClickHandler(rec.doLogin)}>
                Login
              </button>
            )}
          </Subscribe>

          {/* GOOGLE LOGIN */}
          <Subscribe to={[RECSPContainer]}>
            {rec=>(
              <GoogleLogin
                className="googlebtn"
                clientId="966541688745-ml0v25mp23b44st2pnoojif5gfsh8juu.apps.googleusercontent.com"
                buttonText="Login with Google"
                onSuccess={(data)=>resGoogle(data,rec.doLogin)}
                cookiePolicy={"single_host_origin"}
              />
            )}
          </Subscribe>

          {/* REGISTER LINK */}
          <div className="register-link-container">
            <span>Don't have an account?</span>
            <button className="register-link-btn" onClick={()=>setLocation("/register")}>
              Register Now
            </button>
          </div>
        </div>
      </div>
    </Layout2>
  );
}
